// Fork: internal-only edit history for a timeline note.
import { useState } from 'react'
import type { TimelineEntry } from '../../api/types'
import { describeNoteVersion, readableNoteText } from './noteRevisions'

function formatWhen(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function NoteHistory({ original, revisions }: { original: TimelineEntry; revisions: TimelineEntry[] }) {
  const [open, setOpen] = useState(false)
  const textEdited = revisions.some(revision => typeof revision.content?.note_message === 'string')
  return (
    <div className="mt-2">
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="text-xs text-text-tertiary hover:text-text-primary">
        Edited · {open ? 'Hide history' : 'Show history'}
      </button>
      {open && (
        <ol className="mt-2 space-y-1 text-xs text-text-secondary border-l border-border pl-3">
          <li>
            Posted {formatWhen(original.timestamp)} as {describeNoteVersion(original.type, original.content?.status_label).toLowerCase()}
            {textEdited && <span className="block whitespace-pre-wrap text-text-tertiary">Original text: “{readableNoteText(original)}”</span>}
          </li>
          {revisions.map(revision => {
            const content = revision.content ?? {}
            return (
              <li key={revision.id}>
                {revision.actor_name || revision.actor_id || 'Someone'} changed it on {formatWhen(revision.timestamp)} to{' '}
                {describeNoteVersion(content.note_type, content.status_label).toLowerCase()}
                {typeof content.note_timestamp === 'string' && <> at {formatWhen(content.note_timestamp)}</>}
                {typeof content.note_message === 'string' && <>, and edited the text</>}
              </li>
            )
          })}
        </ol>
      )}
    </div>
  )
}
